<div class="wrapper">
  <app-sidebar />

  <app-topbar (settingsButtonClicked)="onSettingsButtonClicked()" (mobileMenuButtonClicked)="onToggleMobileMenu()"  (mobileMenuClose)="closeSidebar()" />

  <div class="page-content">
    <div class="page-container">
      <router-outlet />
    </div>

      <app-footer class="mt-auto"/>

  </div>

</div>